import { render, staticRenderFns } from "./taili_doc.vue?vue&type=template&id=05513c14&scoped=true"
import script from "./taili_doc.vue?vue&type=script&lang=js"
export * from "./taili_doc.vue?vue&type=script&lang=js"
import style0 from "./taili_doc.vue?vue&type=style&index=0&id=05513c14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05513c14",
  null
  
)

export default component.exports